import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { ReactComponent as png } from '../assets/images/fileIcons/png.svg';
import { ReactComponent as jpg } from '../assets/images/fileIcons/jpg.svg';
import { ReactComponent as eps } from '../assets/images/fileIcons/eps.svg';
import { ReactComponent as pdf } from '../assets/images/fileIcons/pdf.svg';
import { ReactComponent as ai } from '../assets/images/fileIcons/ai.svg';
export interface FileIconProps {
    name: string;
}

export const fileIconIndex: any = { png, jpg, eps, pdf, ai };

class FileIcon extends React.Component<FileIconProps> {
    static contextType: Context<AppContextInterface | null> = AppContext;
    static context: AppContextInterface;

    render() {
        let FileIconSvg = fileIconIndex[this.props.name?.replace('.', '')];
        if (!FileIconSvg) {
            return null;
        }
        return (<FileIconSvg className="file-icon" />);
    }
}

export default FileIcon;
